export default "__VITE_ASSET__0jxYvLO4__"